<template>
  <div class="detail">
    <!-- 海外仓异常详情 -->
    <div class="baseBreadcrumb">
      <baseBreadcrumb :page="$t('message.abnormalArrivalRegistration')" :menu="$t('message.problemSolving')"
        :menu1="$t('message.detail')" />
      <el-button @click="$parent.isShowDetail = false">返回</el-button>
    </div>
    <div class="body">
      <div class="order">
        到货异常登记：<span>{{ detail.abnormal_sn || '-' }} </span>
        <el-tag :type="detail.status == 1 ? 'primary' : 'success'" size="mini">
          {{ detail.status_name }}
        </el-tag>
      </div>
      <div class="item-head">
        基本信息
      </div>
      <div class="base-info">
        <div class="item">
          <div class="row">
            <div class="label">入库类型</div>
            <div class="value">{{ detail.abnormal_type_name }}</div>
          </div>
          <div class="row">
            <div class="label">入库托盘数</div>
            <div class="value">{{ detail.pallet_num }}</div>
          </div>
        </div>
        <div class="item">
          <div class="row">
            <div class="label">仓库</div>
            <div class="value">{{ detail.wms_name || '-' }}</div>
          </div>
          <div class="row">
            <div class="label">提出时间</div>
            <div class="value">{{ detail.created_at || '-' }}</div>
          </div>
        </div>
        <div class="item">
          <div class="row">
            <div class="label">到仓方式</div>
            <div class="value">{{ detail.arrive_type || '-' }}</div>
          </div>
          <div class="row">
            <div class="label">跟踪单号</div>
            <div class="value">{{ detail.tracking_no || '-' }}</div>
          </div>
        </div>
      </div>
      <div class="item-head">
        产品信息
      </div>
      <div class="productInformation">
        <div class="head">
          <div class="item">
            总产品数：<span>{{ detail.summary.total_sku_count }}</span>
          </div>
          <div class="item">
            总箱数：<span>{{ detail.summary.total_box_count }}</span>
          </div>
          <div class="item">
            总体积：<span>{{ detail.summary.total_volume }}</span>
          </div>
          <div class="item">
            总重量：<span>{{ detail.summary.total_weight }}</span>
          </div>
        </div>
        <!-- 一件代发 -->
        <div class="dropShipping" v-if="detail.abnormal_type == 1">
          <div class="table">
            <ol>
              <li class="flex05">商品图片</li>
              <li class="flex15">产品名称</li>
              <li>SKU</li>
              <li>RSKU</li>
              <li>异常数量</li>
              <li>异常原因</li>
              <li class="flex15">仓库备注</li>
              <li class="flex2">处理方式</li>
              <li class="flex15">备注</li>
            </ol>
            <div v-for="(box, boxIndex) in detail.box_groups" :key="boxIndex">
              <ul v-for="(item, itemIndex) in box.products" :key="itemIndex">
                <li class="flex05">
                  <el-image :src="item.image" fit="contain" :preview-src-list="[item.image]"
                    style="width: 60px ;height: 60px;" />
                </li>
                <li class="flex15">{{ item.product_name }}</li>
                <li>
                  <p>{{ item.sku }}</p>
                </li>
                <li>{{ item.rsku }}</li>
                <li>{{ item.abnormal_num }}</li>
                <li>
                  {{ item.abnormal_reason }}
                </li>
                <li class="flex15">
                  <el-input v-model="item.warehouse_remark" type="textarea" disabled />
                </li>
                <li class="flex2">
                  <div class="template">
                    <el-radio :label="1" v-model="item.handle_opinion" :disabled="isHandle">允许入库</el-radio>
                    <el-radio :label="2" v-model="item.handle_opinion" :disabled="isHandle">禁止入库</el-radio>
                  </div>
                </li>
                <li class="flex15">
                  <el-input v-model="item.business_remark" type="textarea" :disabled="isHandle" />
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- 备货中转 -->
        <div class="preparationTransit" v-if="detail.abnormal_type == 2">
          <div class="table">
            <ol>
              <li class="flex05"></li>
              <li>箱号</li>
              <li>箱唛号</li>
              <li>尺寸（cm）</li>
              <li>重量（kg）</li>
              <li>产品种类</li>
              <li>异常原因</li>
              <li class="flex15">备注</li>
              <li class="flex2">处理方式</li>
            </ol>
            <div v-for="(box, boxIndex) in detail.boxes" :key="boxIndex">
              <ul>
                <li class="flex05">
                  <!--展开 收起 -->
                  <div class="switch" @click="box.show = !box.show">
                    {{ box.show ? '收起' : '展开' }} <i
                      :class="{ 'el-icon-arrow-up': box.show, 'el-icon-arrow-down': !box.show }"></i>
                  </div>

                </li>
                <li>{{ box.box_number }}</li>
                <li>
                  <p>{{ box.box_code }}</p>
                </li>
                <li>{{ box.size }}</li>
                <li>{{ box.weight }}</li>
                <li>{{ box.total_num }}</li>
                <li>{{ box.abnormal_reason }}</li>
                <li class="flex15">
                  <el-input v-model="box.business_remark" type="textarea" :disabled="isHandle" />
                </li>
                <li class="flex2">
                  <div class="template">
                    <el-radio :label="1" v-model="box.handle_opinion" :disabled="isHandle">允许入库</el-radio>
                    <el-radio :label="2" v-model="box.handle_opinion" :disabled="isHandle">禁止入库</el-radio>
                  </div>
                </li>
              </ul>
              <!-- 产品信息 -->
              <div class="products" v-show="box.show">
                <ol style="background-color: #DCDFE6;">
                  <li>产品名称</li>
                  <li>SKU</li>
                  <li>RSKU</li>
                  <li>数量</li>
                </ol>
                <ul v-for="(item, itemIndex) in box.products" :key="itemIndex">
                  <li>{{ item.product_name }}</li>
                  <li>{{ item.sku }}</li>
                  <li>{{ item.rsku }}</li>
                  <li>{{ item.num }}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="item-head">
        附件
      </div>
      <div class="file">
        <div class="item" v-for="(item, index) in detail.files" :key="index">
          <a :href="item" target="_blank">
            <img src="@/assets/img/file.png" alt="">
            <p>{{ item }}</p>
          </a>
        </div>
      </div>
      <!-- 一件代发 -->
      <div class="btn" v-if="!isHandle && detail.abnormal_type == 1">
        <el-button type="primary" @click="dropShipping">提交</el-button>
      </div>
      <!-- 备货中转 -->
      <div class="btn" v-if="!isHandle && detail.abnormal_type == 2">
        <el-button type="primary" @click="preparationTransit">提交</el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      detail: {
        summary: {},
      },
      isHandle: false,
    };
  },
  methods: {
    // 海外仓异常详情
    abnormalArrivalDetail(abnormal_sn) {
      this.$api.overseasWarehouseApi.abnormalArrivalDetail({ abnormal_sn }).then(res => {
        if (res.data.abnormal_type == 2) {
          res.data.boxes.forEach(box => {
            box.show = false
          })
        }

        this.detail = res.data
      })
    },
    // 海外仓异常处理 一件代发
    dropShipping() {
      let datas = {
        abnormal_sn: this.detail.abnormal_sn,
        handled_by: JSON.parse(localStorage.getItem('japanUserRoleInfo')).id,
        details: []
      }
      this.detail.box_groups.forEach(box => {
        box.products.forEach(item => {
          datas.details.push({
            id: item.id,
            handle_opinion: item.handle_opinion,
            business_remark: item.business_remark,
          })
        })
      })
      if (datas.details.some(item => item.handle_opinion === null)) {
        this.$message.error('请选择处理方式')
        return
      }
      this.$api.overseasWarehouseApi.abnormalArrivalHandle(datas).then(res => {
        this.$message.success(res.msg)
        this.$parent.isShowDetail = false
        this.$parent.abnormalArrivalList()
      })
    },
    // 海外仓异常处理 备货中转
    preparationTransit() {
      let datas = {
        abnormal_sn: this.detail.abnormal_sn,
        handled_by: JSON.parse(localStorage.getItem('japanUserRoleInfo')).id,
        details: []
      }
      this.detail.boxes.forEach(box => {
        datas.details.push({
          id: box.id,
          handle_opinion: box.handle_opinion,
          business_remark: box.business_remark,
        })
      })
      if (datas.details.some(item => item.handle_opinion === null)) {
        this.$message.error('请选择处理方式')
        return
      }

      this.$api.overseasWarehouseApi.abnormalArrivalHandle(datas).then(res => {
        this.$message.success(res.msg)
        this.$parent.isShowDetail = false
        this.$parent.abnormalArrivalList()
      })
    }
  }
}
</script>
<style lang='scss' scoped>
.detail {
  .baseBreadcrumb {
    position: relative;

    .el-button {
      position: absolute;
      right: 0;
      top: 5px;
    }
  }

  .order {
    margin-bottom: 15px;
    font-size: 16px;

    span {
      font-weight: bold;
      margin-right: 18px;
    }
  }

  .item-head {
    font-size: 24px;
    font-weight: bold;
    margin: 0px 0 24px 0px;
    border-top: 1px solid #E4E7ED;
    padding-top: 42px;
  }

  .base-info {
    display: flex;
    background-color: #fff;
    padding: 24px 0;
    border-radius: 4px;
    margin-bottom: 40px;

    .item {
      flex: 1;
      padding: 0 30px;
      border-left: 1px solid #E4E7ED;

      &:first-child {
        border-left: none;
      }

      .row {
        margin-bottom: 12px;
        display: flex;

        .label {
          width: 100px;
          color: #666666;
        }

        .value {
          flex: 1;
          color: #333333;
        }

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }

  .productInformation {
    .head {
      display: flex;
      padding: 24px 0 12px;

      .item {
        margin-right: 30px;
        color: #666666;

        span {
          color: #333333;
          font-weight: bold;
        }
      }
    }

    .dropShipping {
      margin-bottom: 42px;
    }

    .preparationTransit {
      margin-bottom: 42px;

      .switch {
        width: 48px;
        height: 12px;
        border-radius: 4px;
        padding: 6px;
        background-color: #F6F6F6;
        color: #999;
        font-size: 12px;
        display: flex;
        justify-content: space-between;
        line-height: 12px;
        cursor: pointer;
      }
    }

    ol {
      height: 48px;
    }

    ul {
      padding: 20px 0;
      background-color: #fff;
    }

    li {
      margin-right: 30px;
      text-align: center;

      &:last-child {
        margin-right: 0;
      }
    }

    .flex05 {
      flex: 0.6;
    }

    .flex15 {
      flex: 1.5;
    }

    .flex2 {
      flex: 2;
    }
  }

  .file {
    padding: 24px;
    background-color: #fff;
    display: flex;
    border-radius: 4px;
    margin-bottom: 42px;

    .item {
      margin-right: 24px;
      width: 120px;
      text-align: center;

      img {
        width: 50px;
        height: 50px;
      }

      p {
        line-height: 22px;
        color: #333;
      }
    }
  }
}
</style>